import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import moment from "moment";
import { DATE_FORMAT } from "../../constants";
import altSurecBasvuruSayilari from "../../services/altSurecBasvuruSayilari";
import altSurecVeDurumaGoreBasvuruListesi from "../../services/altSurecVeDurumaGoreBasvuruListesi";
import useColumns from "../../hooks/useColumns";
import { Table, Card, Row, Col, Drawer, Modal, Spin, Input, Space, Button, Tooltip as TooltipAnd } from 'antd';
import { UnorderedListOutlined, SearchOutlined, OrderedListOutlined ,FileExcelOutlined} from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis,ResponsiveContainer } from "recharts";
import ExcelExport from './../ExcelExport';
import basvuruStateZamanlariList from "../../services/basvuruStateZamanlariLists";

const parsed = queryString.parse(history.location.search);

const AltSurecBasvuruRapor = () =>{

    const [dates, setDates] = useState([moment(), moment()]);
    const [altSurecBasvurus, setAltSurecBasvurus] = useState([]);
    const [totalCountbasvurular, setTotalCountbasvurular] = useState(0);
    const [visible, setVisible] = useState(false);
    const [queryDates, setQueryDates] = useState([undefined, undefined]);
    const [basvurular, setBasvurular] = useState([]);
    const {altSurecBasvuruColumns,basvuruSurecGecmisColumns} = useColumns();
    const belgeGrubuId = parsed.belgeGrubuId.split(',').map(item=> { return parseInt(item)});
    const [spining, setSpining] = useState(true);
    const [filtredBasvurular, setFiltredBasvurular] = useState([]);
    const [altSurecAdi,setAltSurecAdi] = useState();
    const [basvuruStateList, setBasvuruStateList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const basvuruColumnsWithIslem = [...altSurecBasvuruColumns];
    basvuruColumnsWithIslem.push({
      title: 'İşlem',
      key: 'key',
      dataIndex: 'key',
      width: 80,
      fixed: 'right',
      render: (text, record) => (
        <TooltipAnd title="Süreç Geçmişi Görüntüle">
          <Button type="primary" onClick={() => { openModalBasvuruStateList(record.objectid, record.altSurecTipiId) }} shape="circle" icon={<OrderedListOutlined />} />
        </TooltipAnd>
      ),
    })

    const load = async() => {
        await altSurecBasvuruSayilari(belgeGrubuId)
        .then(res=>{
            setAltSurecBasvurus(res.data.result);
        });
        setQueryDates(dates);
        setSpining(false);

    }
    useEffect(()=> {
        load();
    },[]);

    const getAltSurecVeDurumaGoreBasvuruListesi = (altSurecTipiId,stateDurumuIds) => {
      setSpining(true);
      let filterModel= {altSurecTipiId:altSurecTipiId,StateDurumuIds: stateDurumuIds};
      altSurecVeDurumaGoreBasvuruListesi(filterModel)
          .then(res => {
           
            setBasvurular(res.data.result);
            setTotalCountbasvurular(res.data.result.length);
            setSpining(false);
          })
          .catch(ex=> {
            setSpining(false);
          })
      }
    const openModalBasvuruStateList = (basvuruId, altSurecTipiId) => {

    let filterModel = {};

    if (basvuruId !== undefined && basvuruId != null) {
      filterModel.basvuruId = basvuruId;
    }
    if (altSurecTipiId !== undefined && altSurecTipiId != null) {
      filterModel.altSurecTipiId = altSurecTipiId;
    }
    setSpining(true);
    basvuruStateZamanlariList(filterModel)
        .then(res => { console.log("Başarılı"); setBasvuruStateList(res.data.result); setSpining(false); showModal(); })
        .catch(ex => { setSpining(false);});

    };

    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const columns = [
        {
          title: 'Belge Türü',
          dataIndex: 'altSurecTipiAdi',
          key: 'altSurecTipiAdi',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.altSurecTipiAdi}</span>
          </div>
        },
        {
          title: 'Aktif Başvuru Sayısı',
          dataIndex: 'aktif',
          key: 'aktif',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.aktif}</span>
            <UnorderedListOutlined onClick={() => {
              setVisible(true);
              setAltSurecAdi(record.altSurecTipiAdi);
              getAltSurecVeDurumaGoreBasvuruListesi(record.altSurecTipiId, record.aktifId);
            }} />
          </div>
        },
        {
          title: 'Tamamlanan Başvuru Sayısı',
          dataIndex: 'tamamlandi',
          key: 'tamamlandi',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.tamamlandi}</span>
            <UnorderedListOutlined onClick={() => {
              setVisible(true);
              setAltSurecAdi(record.altSurecTipiAdi);
              getAltSurecVeDurumaGoreBasvuruListesi(record.altSurecTipiId, record.tamamlandiId);
            }} />
          </div>
        },
        {
          title: 'Toplam Başvuru Sayısı',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.tamamlandi + record.aktif}</span>
            <UnorderedListOutlined onClick={() => {
              setVisible(true);
              setAltSurecAdi(record.altSurecTipiAdi);
              getAltSurecVeDurumaGoreBasvuruListesi(record.altSurecTipiId,[]);
            }} />
          </div>
        }
    ];
    
    let opKeyTitles = altSurecBasvuruColumns.map(items => { return { key: items.key, title: items.title } });
    
    return  <Spin tip={"Veriler Yükleniyor"} spinning={spining} > 
                <Card style={{ margin: "20px" }} title={<h2 style={{ fontWeight: "bolder", color: "white" }}>Belge Türlerine Göre Başvuru Sayıları</h2>} className="ant-card-head-title-large">
                    <Row gutter={16}>
                        <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12}>
                            <ResponsiveContainer width={700} height="100%">
                                <BarChart  data={altSurecBasvurus}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="altSurecTipiAdi"  angle={-80}  interval={0} height={180}  textAnchor="end"/>
                                    <YAxis />
                                    <Tooltip />
                                    <Bar dataKey="aktif" fill="#0000ff" style={{ cursor: "pointer" }} onClick={(record) => {
                                        setVisible(true);
                                        setAltSurecAdi(record.altSurecTipiAdi);
                                        getAltSurecVeDurumaGoreBasvuruListesi(record.altSurecTipiId,record.aktifId);}} />
                                    <Bar dataKey="tamamlandi" fill="#00ee00" style={{ cursor: "pointer" }} onClick={(record) => {
                                        setVisible(true);
                                        setAltSurecAdi(record.altSurecTipiAdi);
                                        getAltSurecVeDurumaGoreBasvuruListesi(record.altSurecTipiId,record.tamamlandiId);}} />
                                    <Legend  layout={'horizontal'}  />
                                </BarChart>
                            </ResponsiveContainer>
                        </Col>
                        <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12}>
                            <Table bordered dataSource={altSurecBasvurus} columns={columns} 
                                pagination={{
                                showSizeChanger: true,
                                pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
                                total: altSurecBasvurus && altSurecBasvurus.length,
                                showTotal: (total) => <div>{"Toplam: " + total}</div>
                            }}/>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        {visible &&
                        <Card style={{ marginTop: "8px", width: "100%" }}
                            title={<h4 style={{ fontWeight: "bolder", color: "white" }}> {altSurecAdi} Başvuru Bilgileri</h4>}
                            className="ant-card-head-title-medium">
                            <Table scroll={{ x: 1500, y: 500 }}  rowKey={"objectid"} bordered dataSource={basvurular} columns={basvuruColumnsWithIslem}
                            title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3>
                                <ExcelExport
                                fileName={'Başvuru Bilgileri ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
                                downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />} />}
                                sheets={[{ data: basvurular, name: 'Test', keyTitles: opKeyTitles }]} />
                            </div>}
                            onChange={
                                (pagination, filters, sorter, extra) => {
                                if (extra.currentDataSource.length < basvurular.length) {
                                    setTotalCountbasvurular(extra.currentDataSource.length);
                                }
                                else {
                                    setFiltredBasvurular(basvurular);
                                    setTotalCountbasvurular(basvurular.length);
                                }
                                }
                            }
                            pagination={{
                                showSizeChanger: true,
                                pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
                                total: totalCountbasvurular && totalCountbasvurular,
                                showTotal: (total) => <div>{"Toplam: " + total}</div>
                            }}
                            />
                            <Modal title="Başvuru Geçmişi" centered visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                        <Table rowKey={"stateId"} bordered dataSource={basvuruStateList} columns={basvuruSurecGecmisColumns}
                            pagination={{
                            showSizeChanger: true,
                            pageSize:5,
                            pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
                            total: basvuruStateList && basvuruStateList.length,
                            showTotal: (total) => <div>{"Toplam: " + total}</div>
                            }} 
                        />
                        </Modal>
                        </Card>
                        }
                    </Row>
                </Card>
            </Spin>
    }

export default AltSurecBasvuruRapor;